import { render, staticRenderFns } from "./Reto.vue?vue&type=template&id=0f2a0b66"
import script from "./Reto.vue?vue&type=script&lang=js"
export * from "./Reto.vue?vue&type=script&lang=js"
import style0 from "./Reto.vue?vue&type=style&index=0&id=0f2a0b66&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports